import PageContent from "../PageContent/PageContent";
import { useEffect } from "react";

import InfoCover from "../PageContent/PageCovers/InfoCover";
import PropShow from "../PageContent/PropShow";
import BrancoAnim from "../PageContent/BrancoAnim";
import VideoAsk from "../PageContent/VideoAsk";
import VidTestim from "../PageContent/VidTestim";
import Fancy from "../PageContent/Fancy";
import PinkForm from "../PageContent/PinkForm";
import Footer from "../PageContent/Footer";
import CTAButton from "../PageContent/CTAButton";
import Marquee from "../PageContent/Marquee";
import Map from "../PageContent/MapPart";

function Region({ page, title, text }) {
    useEffect(() => {
        document.title = title ? title : page;
    }, [title, page]);

    return (
        <div className="content-ctnr">

            <InfoCover page={page} text={text} />
            <BrancoAnim page={page} text={text} />
            <VideoAsk page={page} text={text} />
            <VidTestim page={page} text={text} />
            <PropShow page={page} text={text} />
            <Marquee />
            <PinkForm page={page} text={text} />
            <Map />
            <Footer page={page} text={text} />

            <CTAButton page={page} />
        </div>
    );
}

export default Region;